import React from "react";
import { Button, Grid } from "@mui/material";
import InternationalAgreements from "./International/InternationalAgreements";
import DomesticAgreements from "./Domestic/DomesticAgreements";
import { checkPermission } from "../../../../Utils/Permissions";
import DomesticView from "./Domestic/DomesticView";
import InternationalView from "./International/InternationalView";

function FinancePage({ hospitalId, isEditable }) {
  const [isDomestic, setIsDomestic] = React.useState(true);
  const [isEditDomestic, setIsEditDomestic] = React.useState(isEditable || true);
  const [isEditInternational, setIsEditInternational] = React.useState(isEditable || true);
  const [internatinalDetails, setInternatinalDetails] = React.useState({
    agreementExpiryFrom: "",
    agreementExpiryTo: "",
    consumables: [],
    contactPersonName: "",
    contactPersonNumber: "",
    hospitalTreatmentShares: [
      {
        mykareShare: "",
        price: "",
        treatmentId: 0,
      },
    ],
    ipMykareShare: "",
    ipRmpHospitalShare: "",
    ipRmpMykareShare: "",
    opMinConsultationFee: "",
    opMykareShare: "",
    partnerIpShare: "",
    partnerOpShare: "",
  });

  const [domesticDetails, setDomesticDetails] = React.useState({
    agreementExpiryFrom: "",
    agreementExpiryTo: "",
    consumables: [],
    contactPersonName: "",
    contactPersonNumber: "",
    hospitalTreatmentShares: [
      {
        mykareShare: "",
        price: "",
        treatmentId: 0,
      },
    ],
    ipMykareShare: "",
    ipRmpHospitalShare: "",
    ipRmpMykareShare: "",
    opMinConsultationFee: "",
    opMykareShare: "",
    partnerIpShare: "",
    partnerOpShare: "",
  });
  return (
    <Grid container item lg={12}>
      <Grid
        container
        item
        lg={12}
        alignItems={"center"}
        justifyContent={"flex-end"}
      >
        {/* {checkPermission("KARE_DB_FINANCE_EDIT") && (
          <Grid container item lg={1.7} justifyContent={"flex-end"}>
            {isDomestic
              ? !isEditDomestic && (
                  <MuiButton
                    onClick={() => {
                      setIsEditDomestic(true);
                    }}
                    padding="10px 20px"
                    viewHeight="30px"
                    bgColor={"#17dfba"}
                    borderRadius="50px"
                    title={"Edit Details"}
                    style={{ position: "absolute", top: "64px" }}
                  />
                )
              : !isEditInternational && (
                  <MuiButton
                    onClick={() => {
                      setIsEditInternational(true);
                    }}
                    padding="10px 20px"
                    viewHeight="30px"
                    bgColor={"#17dfba"}
                    borderRadius="50px"
                    title={"Edit Details"}
                    style={{ position: "absolute", top: "64px" }}
                  />
                )}
          </Grid>
        )} */}
        {/* <Grid container item lg={12}>
          <Grid container item lg={1.6}>
            {
              <Button
                onClick={() => setIsDomestic(true)}
                sx={{
                  backgroundColor: isDomestic ? "#17dfba" : "lightgray",
                  color: "white",
                  textTransform: "capitalize",
                }}
              >
                Domestic Agreements
              </Button>
            }{" "}
          </Grid>
          <Grid container item lg={1.9}>
            <Button
              onClick={() => setIsDomestic(false)}
              sx={{
                backgroundColor: isDomestic ? "lightgray" : "#17dfba",
                color: "white",
                textTransform: "capitalize",
              }}
            >
              International Agreements
            </Button>{" "}
          </Grid>
        </Grid> */}

       

        <Grid
          sx={{
            width: "100%",
            marginTop: "30px",
          }}
         >
          {isDomestic ? (
            <>
              {checkPermission("KARE_DB_FINANCE_EDIT") ? (
                <DomesticAgreements
                  hospitalId={hospitalId}
                  isEditable={isEditDomestic || isEditable}
                  setIsEditable={setIsEditDomestic}
                  domesticDetails={domesticDetails}
                  setDomesticDetails={setDomesticDetails}
                  setIsDomestic={setIsDomestic}
                />
              ) : (
                <DomesticView
                  hospitalId={hospitalId}
                  isEditable={false}
                  setIsEditable={setIsEditDomestic}
                  domesticDetails={domesticDetails}
                  setDomesticDetails={setDomesticDetails}
                />
              )}
            </>
          ) : (
            <>
              {checkPermission("KARE_DB_FINANCE_EDIT") ? (
                <InternationalAgreements
                  hospitalId={hospitalId}
                  isEditable={isEditInternational || isEditable}
                  setIsEditable={setIsEditInternational}
                  domesticDetails={domesticDetails}
                  internatinalDetails={internatinalDetails}
                  setInternatinalDetails={setInternatinalDetails}
                  setIsDomestic={setIsDomestic}
                  setIsEditDomestic={setIsEditDomestic}
                />
              ) : (
                <InternationalView
                  hospitalId={hospitalId}
                  isEditable={false}
                  setIsEditable={setIsEditInternational}
                  internatinalDetails={internatinalDetails}
                  setInternatinalDetails={setInternatinalDetails}
                 
                />
              )}
            </>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default FinancePage;
